import React, { useState, useMemo } from 'react';
import ErrorBoundary from '../../ErrorBoundary';
import SubmitButton from '../formComponents/SubmitButton';
import TagSelector from '../formComponents/TagSelector.js';
import ErrorMessage from '../formComponents/ErrorMessage';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../firebase-client';
const sendBulkInvitesFn = httpsCallable(functions, 'sendBulkInvites');
export default function InviteMembersForm({
  isOpen,
  onClose,
  teamId,
  teamName,
  adminUid,
  teamTags = []
}) {
  const [emailInput, setEmailInput] = useState('');
  const [selectedTags, setSelectedTags] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const parsedEmails = useMemo(() => {
    const emails = emailInput.split(/[\n,;]+/).map(e => e.trim().toLowerCase()).filter(Boolean);
    const valid = [];
    const invalid = [];
    for (const em of emails) {
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em) ? valid.push(em) : invalid.push(em);
    }
    return {
      valid,
      invalid
    };
  }, [emailInput]);
  const handleSubmit = async () => {
    if (!parsedEmails.valid.length) {
      setError('Please enter at least one valid email.');
      return;
    }
    setError('');
    setSubmitting(true);
    try {
      const flattenedTags = Object.values(selectedTags).flat();
      await sendBulkInvitesFn({
        emails: parsedEmails.valid,
        teamId,
        teamName,
        invitedByUid: adminUid,
        tags: flattenedTags
      });
      onClose();
    } catch (err) {
      setError('Something went wrong while inviting members.');
    } finally {
      setSubmitting(false);
    }
  };
  if (!isOpen) return null;
  return <div className="modal-form">
      <h2 className="modal-title">Invite by email</h2>
      <p>Send a joining invitation. Members complete their own details. To bring across existing membership records and paid-through dates from a CSV, use Import existing members.</p>
      <p>Paste one or more email addresses below, separated by commas or new lines. You can also apply tags to all invites.</p>

      <textarea className="input w-full mt-2 mb-3" rows={5} placeholder="user1@example.com, user2@example.com" value={emailInput} onChange={e => setEmailInput(e.target.value)} />

      {teamTags.length > 0 && <ErrorBoundary label="TagSelector">
          <TagSelector allTags={teamTags} selectedTags={selectedTags} onChange={setSelectedTags} />
        </ErrorBoundary>}

      {parsedEmails.invalid.length > 0 && <ErrorBoundary label="ErrorMessage">
          <ErrorMessage>
            The following email(s) are invalid:<br />
            <code>{parsedEmails.invalid.join(', ')}</code>
          </ErrorMessage>
        </ErrorBoundary>}

      <div className="mt-4 flex justify-end gap-2">
  <SubmitButton type="button" label="Cancel" onClick={onClose} disabled={submitting} variant="ghost" size="sm" />
  <ErrorBoundary label="SubmitButton">
    <SubmitButton onClick={handleSubmit} label={`Invite ${parsedEmails.valid.length} member${parsedEmails.valid.length !== 1 ? 's' : ''}`} disabled={submitting || parsedEmails.valid.length === 0} variant="primary" />
  </ErrorBoundary>
    </div>


      {error && <ErrorBoundary label="ErrorMessage">
          <ErrorMessage>{error}</ErrorMessage>
        </ErrorBoundary>}
    </div>;
}
